'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _multireducer = require('multireducer');

var _counter = require('redux/modules/counter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CounterButton = (_dec = (0, _multireducer.connectMultireducer)(function (key, state) {
  return { count: state.multireducer[key].count };
}, { increment: _counter.increment }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(CounterButton, _Component);

  function CounterButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CounterButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CounterButton.__proto__ || (0, _getPrototypeOf2.default)(CounterButton)).call.apply(_ref, [this].concat(args))), _this), _this.props = {
      className: ''
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CounterButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          count = _props.count,
          increment = _props.increment; // eslint-disable-line no-shadow

      var className = this.props.className;

      className += ' btn btn-default';
      return _react2.default.createElement(
        'button',
        { className: className, onClick: increment },
        'You have clicked me ',
        count,
        ' time',
        count === 1 ? '' : 's',
        '.'
      );
    }
  }]);
  return CounterButton;
}(_react.Component), _class2.propTypes = {
  count: _react.PropTypes.number,
  increment: _react.PropTypes.func.isRequired,
  className: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = CounterButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CounterButton/CounterButton.js
// module id = 1502
// module chunks = 0